import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e40318d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-10" }
const _hoisted_2 = {
  key: 0,
  class: "mb-10"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("ENG")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("中文")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("请在此页面底部确认工资")
const _hoisted_6 = {
  class: "tftable mt-10 hidden-xs-only",
  border: "1"
}
const _hoisted_7 = { class: "totalSalary" }
const _hoisted_8 = { class: "totalSalary" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_13 = { class: "totalSalary" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_15 = { class: "totalSalary" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_19 = { class: "totalSalary" }
const _hoisted_20 = { class: "totalSalary" }
const _hoisted_21 = { class: "totalSalary" }
const _hoisted_22 = { class: "totalSalary" }
const _hoisted_23 = { class: "totalSalary" }
const _hoisted_24 = { class: "totalSalary" }
const _hoisted_25 = { class: "totalSalary" }
const _hoisted_26 = { class: "totalSalary" }
const _hoisted_27 = { class: "totalSalary" }
const _hoisted_28 = { class: "totalSalary" }
const _hoisted_29 = { class: "totalSalary" }
const _hoisted_30 = { class: "totalSalary" }
const _hoisted_31 = { class: "totalSalary" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "totalSalary" }, null, -1))
const _hoisted_33 = {
  rowspan: "2",
  colspan: "14",
  style: {"text-align":"left"},
  class: "totalSalary"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = { class: "d-flex align-items-center justify-content--between" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "月度工资", -1))
const _hoisted_37 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "基本工资", -1))
const _hoisted_39 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "职务津贴", -1))
const _hoisted_41 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "年度贡献奖", -1))
const _hoisted_43 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "其他补贴", -1))
const _hoisted_45 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "公司补助", -1))
const _hoisted_47 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "军阶奖", -1))
const _hoisted_49 = { class: "d-flex align-items-center justify-content--between" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "考勤项目", -1))
const _hoisted_51 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_52 = { class: "d-flex align-items-center justify-content--between" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "奖金项目", -1))
const _hoisted_54 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_55 = { class: "d-flex align-items-center justify-content--between" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "提成项目Commission", -1))
const _hoisted_57 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_58 = { class: "d-flex align-items-center justify-content--between" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "其他应发项目:", -1))
const _hoisted_60 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_61 = { class: "d-flex align-items-center justify-content--between" }
const _hoisted_62 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_63 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_64 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_65 = { class: "d-flex align-items-center justify-content--between" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "其他扣款项目", -1))
const _hoisted_67 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_68 = { class: "d-flex align-items-center justify-content--between" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "一次性奖励", -1))
const _hoisted_70 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_71 = { class: "regularTable" }
const _hoisted_72 = /*#__PURE__*/_createTextVNode("指员工每天工作8小时，月度按照 应出勤天数天核算。")
const _hoisted_73 = /*#__PURE__*/_createTextVNode("按各地相关标准，进行核算。举例：深圳市标准为2360。如出现请假、旷工，则按照2360/ 应出勤天数*请假天数。")
const _hoisted_74 = /*#__PURE__*/_createTextVNode("职务津贴总额参照《劳动合同》以及《员工手册》；如出现请假、旷工，则按照相应职级标准额/ 应出勤天数*出勤天数。")
const _hoisted_75 = /*#__PURE__*/_createTextVNode("年度贡献奖总额参照《劳动合同》以及《员工手册》；如出现请假、旷工，年度贡献奖/ 应出勤天数*出勤天数。")
const _hoisted_76 = /*#__PURE__*/_createTextVNode("下班期间临时性处理工作任务的补助。")
const _hoisted_77 = /*#__PURE__*/_createTextVNode("餐补+住房补贴+通讯补贴；如出现请假、旷工，按照补贴总额/ 应出勤天数*出勤天数。")
const _hoisted_78 = /*#__PURE__*/_createTextVNode("根据《军阶》文件中的有关考核条件，达标即可获得对应津贴，未达标，则无此项津贴。")
const _hoisted_79 = /*#__PURE__*/_createTextVNode("根据KPI考核结果评定")
const _hoisted_80 = /*#__PURE__*/_createTextVNode("根据相关考核标准评定")
const _hoisted_81 = /*#__PURE__*/_createTextVNode("根据公司相关提成制度核算")
const _hoisted_82 = /*#__PURE__*/_createTextVNode("按照员工手册有关条例进行核算")
const _hoisted_83 = /*#__PURE__*/_createTextVNode("加班工资=基本工资/应出勤天数*加班天数*劳动法规定的相应系数")
const _hoisted_84 = { class: "getMessageContent" }
const _hoisted_85 = {
  key: 0,
  class: "mb-10"
}
const _hoisted_86 = /*#__PURE__*/_createTextVNode(" 获取短信验证码 ")
const _hoisted_87 = { key: 0 }
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" 获取邮箱验证码 ")
const _hoisted_89 = { key: 0 }
const _hoisted_90 = {
  key: 0,
  class: "mb-10"
}
const _hoisted_91 = {
  key: 1,
  class: "mt-10"
}
const _hoisted_92 = {
  key: 2,
  class: "mt-10"
}
const _hoisted_93 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_94 = /*#__PURE__*/_createTextVNode("确认")

import { inject, ref, Ref, reactive, onBeforeMount, computed } from 'vue'
import dayjs from 'dayjs'
import { getNumber } from '@/utils/index'
import { ElMessage, ElMessageBox} from 'element-plus'
import Lang from '@/lang/index'
import { useLocale, configProviderContextKey } from 'element-plus'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let { 
  'PUT/salaries/payroll': fetchList,
  // 确认工资
  'PUT/salaries/payroll_confirm': payroll_confirmApi,
  // 获取当月汇率
  'GET/salaries/exchange_rate': exchange_rateApi,
  // 发送短信验证码(已登录状态)
  'GET/sms/purpose': purposeApi,
  // 发送邮件验证码
  'GET/mail/send_code': send_codeApi,
} = Api

let viewsLoading: any= inject('viewsLoading')
let personalSalary: any = reactive({})
const month = ref<string>(dayjs().subtract(1, 'month').format('YYYY-MM-DD'))

onBeforeMount(() => {
  monthChange(month.value)
  // transLateFg.value = localStorage.getItem('translateFg') === 'en' ? false : true
})

let rateStr = ref<number>()
const monthChange = async (monthStr: string) => {
  viewsLoading.value = true
  let rep = await fetchList({month: monthStr, oneself: true})
  if(!rep[0]){
    Object.keys(personalSalary).map(key => {
      delete personalSalary[key]
    })
    viewsLoading.value = false
  }
  // 展示数据
  Object.assign(personalSalary, rep[0])
  viewsLoading.value = false
  // 展示汇率
  let { exchangeRate } = await exchange_rateApi({month: monthStr})
  rateStr.value = exchangeRate
}


// 确认工资
const isShowConfirm = ref<boolean>(false)

let code = ref('')
let targetAddr = ref<string>('')
let disabledCode = ref<boolean>(false)
let countDown = ref<number>(60)

const disabledPhone = ref<boolean>(false)
const disabledMail = ref<boolean>(false)

const getCodeHandle = () => {
  disabledPhone.value = true
  purposeApi({purpose: 'SalaryConfirm'}).then((rep) => {
    disabledCode.value = true
    ElMessage.success('发送成功')
    targetAddr.value = (rep as {phone: string}).phone.slice(-4);

    let intervalId = setInterval(() => {
      countDown.value = countDown.value -1
      if(countDown.value === 0){
        countDown.value = 60
        disabledCode.value = false
        disabledPhone.value = false
        clearInterval(intervalId)
      }
    }, 1000)
  })
}
const getMailCodeHandle = () => {
  disabledMail.value = true
  send_codeApi({purpose: 'SalaryConfirm'}).then((rep) => {
    disabledCode.value = true
    ElMessage.success('发送成功')
    targetAddr.value = (rep as {email: string}).email

    let intervalId = setInterval(() => {
      countDown.value = countDown.value -1
      if(countDown.value === 0){
        countDown.value = 60
        disabledCode.value = false
        disabledMail.value = false
        clearInterval(intervalId)
      }
    }, 1000)
  })
}

const comfirmSalaryFg = ref<boolean>(false)
const comfirmSalaryHandle = () => {
  comfirmSalaryFg.value = true
  payroll_confirmApi({distributeIds: personalSalary.distributeIds.join(','), code: code.value}, { contentType: 'formData'})
  .catch(() => {
      ElMessage.info(t('app.salaryDetail.confirmCancel'))
    })
  .finally(() => {
    comfirmSalaryFg.value = false
    disabledCode.value = true
    isShowConfirm.value = false
    monthChange(month.value)
    ElMessage.success(t('app.salaryDetail.success'))
  })
  return
  ElMessageBox.confirm(
    t('app.salaryDetail.confirmPrompt') + dayjs(month.value).format('YYYY-MM'),
    {
      title: 'Tips',
      type: 'warning',
      // 'show-close': false,
    }
  )
    .then(() => {
      viewsLoading.value = true
      return payroll_confirmApi({distributeIds: personalSalary.distributeIds.join(',')}, { contentType: 'formData'})
    })
    .then(() => {
      viewsLoading.value = false
      // 刷新当月工资条，隐藏确认按钮
      monthChange(month.value)
      ElMessage.success(t('app.salaryDetail.success'))
    })
    .catch(() => {
      viewsLoading.value = false
      ElMessage.info(t('app.salaryDetail.confirmCancel'))
    })
}

// -------------翻译-------------
const translate = (str: string) => {
  switch (str) {

    // 考勤
    case '全勤奖':
      return 'Full Attendance Reward'
    case '迟到扣款':
      return 'Late DeductionFull'
    case '请假扣款':
      return 'Leave Deduction'
    case '其他扣款':
      return 'Other Deduction'
    case '个人尽孝金':
      return 'Personal Filial Piety'

      // 提成
    case '团长提成':
      return 'Leader Commission'
    case '部门提成':
      return 'Department Commission'
    case '销售提成':
      return 'Sales Commission'
    case 'PM提成':
      return 'PM Commission'
      
      // 福利
    case '公司尽孝金':
      return 'Company Filial Piety'
    case '行政补贴':
      return 'Administrative Subsidy'
    case '其他福利':
      return 'Other Benefits'
    case '加班津贴':
      return 'Overtime Allowance'

    // 奖金
    case '奖金':
      return 'Bonus'
    case '百万奖金':
      return 'Million Prize'
    case '博客奖':
      return 'Blog Award'
    case '伯乐奖':
      return 'Recruitment Award'
    case '其他奖励':
      return 'Other Award'
    case '导师奖':
      return 'Mentor Award'
    case '绩效':
      return 'Performance Reward'
    case '每月之星':
      return 'Star of the Month'
    case '组长津贴':
      return 'Team Leader Stipend'
    case '工作量前三奖励':
      return 'Top Three Workload Rewards'





    default:
      return '-'
      
  }
}

const reloadApp: any = inject('reloadApp')
const { t } = useLocale()
const elementPlusConfig: any = inject(configProviderContextKey)
const changeLanguage = (locale: any) => {
  elementPlusConfig.value.locale = locale
  reloadApp()
}

const isMobile = computed(() => window.innerWidth <= 768)


return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_descriptions, {
      title: _unref(t)('app.salaryDetail.tableTitle'),
      border: "",
      column: _unref(isMobile) ? 1 : 4,
      direction: _unref(isMobile) ? 'vertical' : 'horizontal'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.name')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(personalSalary).realName), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.enName')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(personalSalary).alias), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.department')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(personalSalary).dept), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.date')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tag, {
              size: "small",
              type: "info"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(personalSalary).month || _unref(dayjs)(month.value).format('YYYY-MM')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_tag, {
              class: "ml-10",
              type: "success"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('app.salaryDetail.rate') + (_unref(rateStr) || '-')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["title", "column", "direction"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_date_picker, {
        modelValue: month.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((month).value = $event)),
        type: "month",
        class: "mr-10",
        onChange: monthChange,
        "value-format": "YYYY-MM-DD",
        placeholder: "请选择月份"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        icon: "Refresh",
        type: "info",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (monthChange(month.value)))
      }),
      (_unref(isMobile))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true),
      _createVNode(_component_el_tooltip, {
        effect: "dark",
        content: "Click to switch language",
        placement: "bottom"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (changeLanguage(_unref(Lang)['en']))),
            plain: ""
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_tooltip, {
        effect: "dark",
        content: "点击切换语言",
        placement: "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (changeLanguage(_unref(Lang)['zh-CN']))),
            plain: ""
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_unref(personalSalary).confirm === false)
        ? (_openBlock(), _createBlock(_component_el_alert, {
            key: 1,
            class: "mt-10",
            closable: false,
            type: "success"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (!_unref(personalSalary).salaryTotal)
      ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 0,
          class: "mt-10",
          type: "danger"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('app.salaryDetail.noData')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_divider, { "content-position": "left" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('app.salaryDetail.summaryTable')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("table", _hoisted_6, [
      _createElementVNode("tr", null, [
        _createElementVNode("th", null, _toDisplayString(_unref(t)('app.salaryDetail.project')), 1),
        _createElementVNode("th", null, _toDisplayString(_unref(t)('app.salaryDetail.totalSalary')), 1),
        _createElementVNode("th", null, _toDisplayString(_unref(t)('app.salaryDetail.totalAttendance')), 1),
        _createElementVNode("th", null, _toDisplayString(_unref(t)('app.salaryDetail.totalBonus')), 1),
        _createElementVNode("th", null, _toDisplayString(_unref(t)('app.salaryDetail.totalCommission')), 1),
        _createElementVNode("th", null, _toDisplayString(_unref(t)('app.salaryDetail.otherBenefits')), 1),
        _createElementVNode("th", null, _toDisplayString(_unref(t)('app.salaryDetail.paymentDueMonth')), 1),
        _createElementVNode("th", null, _toDisplayString(_unref(t)('app.salaryDetail.personalInsuranceTax')), 1),
        _createElementVNode("th", null, _toDisplayString(_unref(t)('app.salaryDetail.otherDeductedFee')), 1),
        _createElementVNode("th", null, _toDisplayString(_unref(t)('app.salaryDetail.totalDeducted')), 1),
        _createElementVNode("th", null, _toDisplayString(_unref(t)('app.salaryDetail.totalActualSalary')), 1),
        _createElementVNode("th", null, _toDisplayString(_unref(t)('app.salaryDetail.payFromFinancialPart')), 1),
        _createElementVNode("th", null, _toDisplayString(_unref(t)('app.salaryDetail.filialPiety')), 1),
        _createElementVNode("th", null, _toDisplayString(_unref(t)('app.salaryDetail.oneTimeReward')), 1)
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, _toDisplayString(_unref(t)('app.salaryDetail.issuedThroughPayroll')), 1),
        _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).salaryTotal)), 1),
        _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).attendanceTotal)), 1),
        _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).bonusTotal)), 1),
        _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).commissionTotal)), 1),
        _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).otherTotal)), 1),
        _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(getNumber)(_unref(personalSalary).totalSalary)), 1),
        _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).personalTotal)), 1),
        _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).otherDeductionTotal)), 1),
        _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).totalDeducted)), 1),
        _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(getNumber)(_unref(personalSalary).actualSalary)), 1),
        _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).salaryCard)), 1),
        _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).filialCard)), 1),
        _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).oneTimeReward ? _unref(personalSalary).oneTimeReward.totalAmount : 0)), 1)
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, _toDisplayString(_unref(t)('app.salaryDetail.issuedThroughOtherChannels')), 1),
        _hoisted_9,
        _hoisted_10,
        _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).alreadyBonusTotal)), 1),
        _hoisted_11,
        _hoisted_12,
        _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(getNumber)(_unref(personalSalary).alreadyTotalSalary)), 1),
        _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).alreadyBonusTaxTotal)), 1),
        _hoisted_14,
        _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).alreadyTotalDeducted    )), 1),
        _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(getNumber)(_unref(personalSalary).alreadyActualSalary)), 1),
        _hoisted_16,
        _hoisted_17,
        _hoisted_18
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(t)('app.salaryDetail.summary')), 1),
        _createElementVNode("td", _hoisted_20, _toDisplayString(_unref(personalSalary).sumSalaryTotal), 1),
        _createElementVNode("td", _hoisted_21, _toDisplayString(_unref(personalSalary).sumAttendanceTotal), 1),
        _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(personalSalary).sumBonusTotal), 1),
        _createElementVNode("td", _hoisted_23, _toDisplayString(_unref(personalSalary).sumCommissionTotal), 1),
        _createElementVNode("td", _hoisted_24, _toDisplayString(_unref(personalSalary).sumOtherTotal), 1),
        _createElementVNode("td", _hoisted_25, _toDisplayString(_unref(personalSalary).sumTotalSalary), 1),
        _createElementVNode("td", _hoisted_26, _toDisplayString(_unref(personalSalary).sumPersonalTotal), 1),
        _createElementVNode("td", _hoisted_27, _toDisplayString(_unref(personalSalary).sumOtherDeductionTotal), 1),
        _createElementVNode("td", _hoisted_28, _toDisplayString(_unref(personalSalary).sumTotalDeducted), 1),
        _createElementVNode("td", _hoisted_29, _toDisplayString(_unref(personalSalary).sumActualSalary), 1),
        _createElementVNode("td", _hoisted_30, _toDisplayString(_unref(personalSalary).sumSalaryCard), 1),
        _createElementVNode("td", _hoisted_31, _toDisplayString(_unref(personalSalary).sumFilialCard), 1),
        _hoisted_32
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_33, [
          _createTextVNode(_toDisplayString(_unref(t)('app.salaryDetail.remark')) + " ", 1),
          _hoisted_34,
          _createTextVNode(_toDisplayString(_unref(personalSalary).remarks), 1)
        ])
      ])
    ]),
    _createVNode(_component_el_descriptions, {
      border: "",
      column: 1,
      title: _unref(t)('app.salaryDetail.issuedThroughPayroll'),
      class: "hidden-sm-and-up"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.totalSalary'),
          width: "100"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(personalSalary).salaryTotal)), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.totalAttendance')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(personalSalary).attendanceTotal)), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.totalBonus')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(personalSalary).bonusTotal)), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.totalCommission')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(personalSalary).commissionTotal)), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.otherBenefits')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(personalSalary).otherTotal)), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.paymentDueMonth')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(personalSalary).totalSalary)), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.personalInsuranceTax')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(personalSalary).personalTotal)), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.otherDeductedFee')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(personalSalary).otherDeductionTotal)), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.totalDeducted')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(personalSalary).totalDeducted)), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.totalActualSalary')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(personalSalary).actualSalary)), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.payFromFinancialPart')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(personalSalary).salaryCard)), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.filialPiety')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(personalSalary).filialCard)), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.oneTimeReward')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(personalSalary).oneTimeReward ? _unref(personalSalary).oneTimeReward.totalAmount : 0)), 1)
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_el_descriptions, {
      border: "",
      column: 1,
      title: _unref(t)('app.salaryDetail.issuedThroughOtherChannels'),
      class: "hidden-sm-and-up"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.paymentDueMonth'),
          width: "100"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(personalSalary).alreadyTotalSalary), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.totalActualSalary')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(personalSalary).alreadyActualSalary), 1)
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_el_descriptions, {
      border: "",
      column: 1,
      title: _unref(t)('app.salaryDetail.summary'),
      class: "hidden-sm-and-up"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.totalSalary'),
          width: "100"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(personalSalary).sumSalaryTotal), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.totalAttendance')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(personalSalary).sumAttendanceTotal), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.totalBonus')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(personalSalary).sumBonusTotal), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.totalCommission')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(personalSalary).sumCommissionTotal), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.otherBenefits')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(personalSalary).sumOtherTotal), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.paymentDueMonth')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(personalSalary).sumTotalSalary), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.personalInsuranceTax')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(personalSalary).sumPersonalTotal), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.otherDeductedFee')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(personalSalary).sumOtherDeductionTotal), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.totalDeducted')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(personalSalary).sumTotalDeducted), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.totalActualSalary')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(personalSalary).sumActualSalary), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.payFromFinancialPart')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(personalSalary).sumSalaryCard), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.filialPiety')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(personalSalary).sumFilialCard), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_descriptions_item, {
          label: _unref(t)('app.salaryDetail.oneTimeReward')
        }, null, 8, ["label"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_el_divider, { "content-position": "left" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('app.salaryDetail.dividerTips')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      class: "mt-10",
      style: {"width":"270px"}
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("p", null, "合计：" + _toDisplayString(_unref(getNumber)(_unref(personalSalary).salaryTotal)), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("span", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).basicSalary)), 1)
        ]),
        _createElementVNode("div", _hoisted_39, [
          _hoisted_40,
          _createElementVNode("span", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).jobAllowance)), 1)
        ]),
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("span", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).postAllowance)), 1)
        ]),
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("span", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).otherAllowance)), 1)
        ]),
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          _createElementVNode("span", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).companyAllowance)), 1)
        ]),
        _createElementVNode("div", _hoisted_47, [
          _hoisted_48,
          _createElementVNode("span", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).rankAllowance)), 1)
        ])
      ]),
      _: 1
    }),
    (_unref(personalSalary).attendance &&  _unref(personalSalary).attendance.totalAmount > 0)
      ? (_openBlock(), _createBlock(_component_el_card, {
          key: 1,
          class: "mt-10",
          style: {"width":"270px"}
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _createElementVNode("p", null, "合计：" + _toDisplayString(_unref(getNumber)(_unref(personalSalary).attendance.totalAmount)), 1)
            ])
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(personalSalary).attendance.dataList, (_attend) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_51, [
                _createElementVNode("span", null, [
                  _createElementVNode("p", null, _toDisplayString(_attend.Label), 1)
                ]),
                _createElementVNode("span", null, _toDisplayString(_unref(getNumber)(_attend.amount)), 1)
              ]))
            }), 256))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(personalSalary).reward && _unref(personalSalary).reward.totalAmount > 0)
      ? (_openBlock(), _createBlock(_component_el_card, {
          key: 2,
          class: "mt-10",
          style: {"width":"270px"}
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_52, [
              _hoisted_53,
              _createElementVNode("p", null, "合计：" + _toDisplayString(_unref(getNumber)(_unref(personalSalary).reward.totalAmount)), 1)
            ])
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(personalSalary).reward.dataList, (_reward) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_54, [
                _createElementVNode("span", null, _toDisplayString(_reward.Label), 1),
                _createElementVNode("span", null, _toDisplayString(_unref(getNumber)(_reward.amount)), 1)
              ]))
            }), 256))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(personalSalary).commission && _unref(personalSalary).commission.totalAmount > 0)
      ? (_openBlock(), _createBlock(_component_el_card, {
          key: 3,
          class: "mt-10",
          style: {"width":"270px"}
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_55, [
              _hoisted_56,
              _createElementVNode("p", null, "合计：" + _toDisplayString(_unref(getNumber)(_unref(personalSalary).commission.totalAmount)), 1)
            ])
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(personalSalary).commission.dataList, (_commission) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_57, [
                _createElementVNode("span", null, _toDisplayString(_commission.Label), 1),
                _createElementVNode("span", null, _toDisplayString(_unref(getNumber)(_commission.amount)), 1)
              ]))
            }), 256))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(personalSalary).other || _unref(personalSalary).benefits)
      ? (_openBlock(), _createBlock(_component_el_card, {
          key: 4,
          class: "mt-10",
          style: {"width":"270px"}
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_58, [
              _hoisted_59,
              _createElementVNode("p", null, "合计：" + _toDisplayString(_unref(getNumber)(_unref(personalSalary).other.totalAmount + (_unref(personalSalary).benefits.totalAmount ? _unref(personalSalary).benefits.totalAmount : 0))), 1)
            ])
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(personalSalary).other.dataList.concat(_unref(personalSalary).benefits.dataList), (_other) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_60, [
                _createElementVNode("span", null, _toDisplayString(_other.Label), 1),
                _createElementVNode("span", null, _toDisplayString(_unref(getNumber)(_other.amount)), 1)
              ]))
            }), 256))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_card, {
      class: "mt-10",
      style: {"width":"270px"}
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('app.salaryDetail.InsuranceTax')), 1),
          _createElementVNode("p", null, "合计：" + _toDisplayString(_unref(getNumber)(_unref(personalSalary).personalTotal)), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('app.salaryDetail.personalInsurance')), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).personalSocialSecurity)), 1)
        ]),
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('app.salaryDetail.personalHousing')), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).personalHousing)), 1)
        ]),
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('app.salaryDetail.personalIncomeTax')), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(getNumber)(_unref(personalSalary).personalTax)), 1)
        ])
      ]),
      _: 1
    }),
    (_unref(personalSalary).otherDeduction)
      ? (_openBlock(), _createBlock(_component_el_card, {
          key: 5,
          class: "mt-10",
          style: {"width":"270px"}
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_65, [
              _hoisted_66,
              _createElementVNode("p", null, "合计：" + _toDisplayString(_unref(getNumber)(_unref(personalSalary).otherDeduction.totalAmount)), 1)
            ])
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(personalSalary).otherDeduction.dataList, (_other) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_67, [
                _createElementVNode("span", null, _toDisplayString(_other.Label), 1),
                _createElementVNode("span", null, _toDisplayString(_unref(getNumber)(_other.amount)), 1)
              ]))
            }), 256))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(personalSalary).oneTimeReward)
      ? (_openBlock(), _createBlock(_component_el_card, {
          key: 6,
          class: "mt-10",
          style: {"width":"270px"}
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_68, [
              _hoisted_69,
              _createElementVNode("p", null, "合计：" + _toDisplayString(_unref(getNumber)(_unref(personalSalary).oneTimeReward.totalAmount)), 1)
            ])
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(personalSalary).oneTimeReward.dataList, (_once) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_70, [
                _createElementVNode("span", null, _toDisplayString(_once.Label), 1),
                _createElementVNode("span", null, _toDisplayString(_unref(getNumber)(_once.amount)), 1)
              ]))
            }), 256))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_divider, { "content-position": "left" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('app.salaryDetail.explain')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_71, [
      _createVNode(_component_el_descriptions, {
        border: "",
        column: 1,
        direction: _unref(isMobile) ? 'vertical' : 'horizontal'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, { label: "月度工资" }, {
            default: _withCtx(() => [
              _hoisted_72
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "基本工资" }, {
            default: _withCtx(() => [
              _hoisted_73
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "职务津贴" }, {
            default: _withCtx(() => [
              _hoisted_74
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "年度贡献奖" }, {
            default: _withCtx(() => [
              _hoisted_75
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "值班补贴" }, {
            default: _withCtx(() => [
              _hoisted_76
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "公司补助" }, {
            default: _withCtx(() => [
              _hoisted_77
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "军阶奖" }, {
            default: _withCtx(() => [
              _hoisted_78
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "绩效" }, {
            default: _withCtx(() => [
              _hoisted_79
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "其他奖励" }, {
            default: _withCtx(() => [
              _hoisted_80
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "提成" }, {
            default: _withCtx(() => [
              _hoisted_81
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "病假" }, {
            default: _withCtx(() => [
              _hoisted_82
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "加班" }, {
            default: _withCtx(() => [
              _hoisted_83
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["direction"]),
      _createVNode(_component_el_alert, {
        class: "mt-10 mb-20",
        title: "备注：本人对上述所有统计及金额计算无异议，本月及以前的加班已经支付费；本月之前的工资、带薪年休假待遇等各类劳动报酬均已结清，上述款项本人已收到。",
        effect: "dark",
        type: "warning",
        closable: false
      })
    ]),
    (_unref(personalSalary).confirm === false)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 7,
          class: "mt-10 confirmBtn",
          type: "primary",
          size: "large",
          onClick: _cache[4] || (_cache[4] = ($event: any) => {isShowConfirm.value = true; _isRef(code) //@ts-ignore
 ? code.value = '' : code = ''})
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('app.salaryDetail.confirmSalary')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      title: "确认工资",
      modelValue: isShowConfirm.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((isShowConfirm).value = $event)),
      width: _unref(isMobile) ? '95vw' : '600px'
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (isShowConfirm.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_93
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          loading: comfirmSalaryFg.value,
          type: "success",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (comfirmSalaryHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_94
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_84, [
          _createVNode(_component_el_alert, {
            title: "请输入短信或邮箱验证码以确认",
            type: "warning",
            closable: false,
            class: "mb-10"
          }),
          _createVNode(_component_el_input, {
            modelValue: _unref(code),
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(code) ? (code).value = $event : code = $event)),
            placeholder: "请输入验证码",
            class: "mr-10"
          }, null, 8, ["modelValue"]),
          (_unref(isMobile))
            ? (_openBlock(), _createElementBlock("div", _hoisted_85))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            disabled: _unref(disabledCode),
            loading: !_unref(disabledCode) && disabledPhone.value,
            onClick: _cache[6] || (_cache[6] = ($event: any) => (getCodeHandle())),
            class: "getMeessageBtn",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_86,
              (_unref(disabledCode) && disabledPhone.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_87, "(" + _toDisplayString(_unref(countDown)) + ")", 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled", "loading"]),
          _createVNode(_component_el_button, {
            disabled: _unref(disabledCode),
            loading: !_unref(disabledCode) && disabledMail.value,
            onClick: _cache[7] || (_cache[7] = ($event: any) => (getMailCodeHandle())),
            class: "getMeessageBtn"
          }, {
            default: _withCtx(() => [
              _hoisted_88,
              (_unref(disabledCode) && disabledMail.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_89, "(" + _toDisplayString(_unref(countDown)) + ")", 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ]),
        (_unref(isMobile))
          ? (_openBlock(), _createElementBlock("div", _hoisted_90))
          : _createCommentVNode("", true),
        (_unref(disabledCode) && disabledMail.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_91, "验证码已发送到邮箱：" + _toDisplayString(_unref(targetAddr)), 1))
          : _createCommentVNode("", true),
        (_unref(disabledCode) && disabledPhone.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_92, "验证码已发送到手机尾号：" + _toDisplayString(_unref(targetAddr)), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "width"])
  ]))
}
}

})